import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import LoanFilter from '../loanFilter'
import LoanList from '@components/list/loanList'
import TablePageHandler from '../tablePageHandler'
import NotLoanCard from '@components/card/NotLoanCard'

import {
  listClosedLoans as listClosedLoansAction
} from '@stores/actions/loan'

import { Container } from './styles'

const ClosedLoanTable = ({
  closedLoans, listClosedLoans, totalClosed
}) => {

  const [searchTerm, setSearchTerm] = useState('')
  const [page, setPage] = useState(0)
  const [pageSize, setPageSize] = useState(10)
  const [filterState, setFilterState] = useState({
    startDate: null,
    endDate: null,
    timeInterval: null,
    equipments: null,
  })

  useEffect(() => {
    listClosedLoans(
      {
        searchTerm: searchTerm === '' ? null : searchTerm,
        ...filterState,
        status: 1,
        page: page + 1,
        pageSize
      }
    )
  }, [page, pageSize, filterState])

  const onSearchClosedLoans = () => {
    listClosedLoans(
      {
        searchTerm: searchTerm === '' ? null : searchTerm,
        ...filterState,
        status: 1,
        page: page + 1,
        pageSize
      }
    )
  }

  if (!closedLoans) {
    return null
  }

  return (
    <Container>
      <LoanFilter
        searchTerm={searchTerm}
        onInputChange={setSearchTerm}
        onSearch={onSearchClosedLoans}
        setFilterState={setFilterState}
      />
      {totalClosed !== 0 ? (
        <>
          <LoanList
            loans={closedLoans}
          />
          <TablePageHandler
            total={totalClosed}
            sizeOnPage={closedLoans && closedLoans?.length}
            page={page + 1}
            pageSize={pageSize}
            setPage={setPage}
            setPageSize={setPageSize}
            isLoan
          />
        </>
      ) : (
        <NotLoanCard
          title="Não há equipamentos devolvidos"
          subtitle="Atualmente, não há empréstimos de equipamentos devolvidos. Se precisar de assistência ou informações adicionais,
          entre em contato com a Central de Ajuda"
        />
      )}

    </Container>
  )

}

ClosedLoanTable.propTypes = {
  listClosedLoans: PropTypes.func.isRequired,
  totalClosed: PropTypes.number,
  closedLoans: PropTypes.object
}

ClosedLoanTable.defaultProps = {
  totalClosed: 0,
  closedLoans: null
}

const mapStateToProps = ({ loan }) => ({
  closedLoans: loan.closedLoans,
  totalClosed: loan.totalClosed
})

const mapDispatchToProps = (dispatch) => bindActionCreators(
  {
    listClosedLoans: listClosedLoansAction
  },
  dispatch
)

export default connect(mapStateToProps, mapDispatchToProps)(ClosedLoanTable)
